/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  InspectionReportAttachment,
  InspectionReportAttachmentRequest,
  InspectionReportCreateUpdate,
  InspectionReportCreateUpdateRequestRequest,
  InspectionReportDetail,
  InspectionReportList,
  InspectionReportListRequest,
  InspectionReportListResponse,
  InspectionReportsListParams,
  PatchedInspectionReportAttachmentRequest,
  PatchedInspectionReportCreateUpdateRequestRequest,
  SupersessionDecisionsRequestRequest,
  SupersessionSummary
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type inspectionReportsListResponse200 = {
  data: InspectionReportListResponse
  status: 200
}

export type inspectionReportsListResponseSuccess = (inspectionReportsListResponse200) & {
  headers: Headers;
};
;

export type inspectionReportsListResponse = (inspectionReportsListResponseSuccess)

export const getInspectionReportsListUrl = (params?: InspectionReportsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["portfolio","property"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/inspection-reports/?${stringifiedParams}` : `/api/v1/inspection-reports/`
}

/**
 * Enhanced list method that includes metadata about inspection reports
 */
export const inspectionReportsList = async (params?: InspectionReportsListParams, options?: RequestInit): Promise<inspectionReportsListResponse> => {

  return customFetch<inspectionReportsListResponse>(getInspectionReportsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type inspectionReportsCreateResponse201 = {
  data: InspectionReportCreateUpdate
  status: 201
}

export type inspectionReportsCreateResponseSuccess = (inspectionReportsCreateResponse201) & {
  headers: Headers;
};
;

export type inspectionReportsCreateResponse = (inspectionReportsCreateResponseSuccess)

export const getInspectionReportsCreateUrl = () => {




  return `/api/v1/inspection-reports/`
}

/**
 * ViewSet for managing inspection reports.
 */
export const inspectionReportsCreate = async (inspectionReportCreateUpdateRequestRequest: InspectionReportCreateUpdateRequestRequest, options?: RequestInit): Promise<inspectionReportsCreateResponse> => {

  return customFetch<inspectionReportsCreateResponse>(getInspectionReportsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inspectionReportCreateUpdateRequestRequest)
  }
);}


export type inspectionReportsAttachmentsListResponse200 = {
  data: InspectionReportAttachment[]
  status: 200
}

export type inspectionReportsAttachmentsListResponseSuccess = (inspectionReportsAttachmentsListResponse200) & {
  headers: Headers;
};
;

export type inspectionReportsAttachmentsListResponse = (inspectionReportsAttachmentsListResponseSuccess)

export const getInspectionReportsAttachmentsListUrl = (inspectionReportPk: string,) => {




  return `/api/v1/inspection-reports/${inspectionReportPk}/attachments/`
}

export const inspectionReportsAttachmentsList = async (inspectionReportPk: string, options?: RequestInit): Promise<inspectionReportsAttachmentsListResponse> => {

  return customFetch<inspectionReportsAttachmentsListResponse>(getInspectionReportsAttachmentsListUrl(inspectionReportPk),
  {
    ...options,
    method: 'GET'


  }
);}


export type inspectionReportsAttachmentsCreateResponse201 = {
  data: InspectionReportAttachment
  status: 201
}

export type inspectionReportsAttachmentsCreateResponseSuccess = (inspectionReportsAttachmentsCreateResponse201) & {
  headers: Headers;
};
;

export type inspectionReportsAttachmentsCreateResponse = (inspectionReportsAttachmentsCreateResponseSuccess)

export const getInspectionReportsAttachmentsCreateUrl = (inspectionReportPk: string,) => {




  return `/api/v1/inspection-reports/${inspectionReportPk}/attachments/`
}

export const inspectionReportsAttachmentsCreate = async (inspectionReportPk: string,
    inspectionReportAttachmentRequest: InspectionReportAttachmentRequest, options?: RequestInit): Promise<inspectionReportsAttachmentsCreateResponse> => {

  return customFetch<inspectionReportsAttachmentsCreateResponse>(getInspectionReportsAttachmentsCreateUrl(inspectionReportPk),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inspectionReportAttachmentRequest)
  }
);}


export type inspectionReportsAttachmentsRetrieveResponse200 = {
  data: InspectionReportAttachment
  status: 200
}

export type inspectionReportsAttachmentsRetrieveResponseSuccess = (inspectionReportsAttachmentsRetrieveResponse200) & {
  headers: Headers;
};
;

export type inspectionReportsAttachmentsRetrieveResponse = (inspectionReportsAttachmentsRetrieveResponseSuccess)

export const getInspectionReportsAttachmentsRetrieveUrl = (inspectionReportPk: string,
    id: string,) => {




  return `/api/v1/inspection-reports/${inspectionReportPk}/attachments/${id}/`
}

export const inspectionReportsAttachmentsRetrieve = async (inspectionReportPk: string,
    id: string, options?: RequestInit): Promise<inspectionReportsAttachmentsRetrieveResponse> => {

  return customFetch<inspectionReportsAttachmentsRetrieveResponse>(getInspectionReportsAttachmentsRetrieveUrl(inspectionReportPk,id),
  {
    ...options,
    method: 'GET'


  }
);}


export type inspectionReportsAttachmentsUpdateResponse200 = {
  data: InspectionReportAttachment
  status: 200
}

export type inspectionReportsAttachmentsUpdateResponseSuccess = (inspectionReportsAttachmentsUpdateResponse200) & {
  headers: Headers;
};
;

export type inspectionReportsAttachmentsUpdateResponse = (inspectionReportsAttachmentsUpdateResponseSuccess)

export const getInspectionReportsAttachmentsUpdateUrl = (inspectionReportPk: string,
    id: string,) => {




  return `/api/v1/inspection-reports/${inspectionReportPk}/attachments/${id}/`
}

export const inspectionReportsAttachmentsUpdate = async (inspectionReportPk: string,
    id: string,
    inspectionReportAttachmentRequest: InspectionReportAttachmentRequest, options?: RequestInit): Promise<inspectionReportsAttachmentsUpdateResponse> => {

  return customFetch<inspectionReportsAttachmentsUpdateResponse>(getInspectionReportsAttachmentsUpdateUrl(inspectionReportPk,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inspectionReportAttachmentRequest)
  }
);}


export type inspectionReportsAttachmentsPartialUpdateResponse200 = {
  data: InspectionReportAttachment
  status: 200
}

export type inspectionReportsAttachmentsPartialUpdateResponseSuccess = (inspectionReportsAttachmentsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type inspectionReportsAttachmentsPartialUpdateResponse = (inspectionReportsAttachmentsPartialUpdateResponseSuccess)

export const getInspectionReportsAttachmentsPartialUpdateUrl = (inspectionReportPk: string,
    id: string,) => {




  return `/api/v1/inspection-reports/${inspectionReportPk}/attachments/${id}/`
}

export const inspectionReportsAttachmentsPartialUpdate = async (inspectionReportPk: string,
    id: string,
    patchedInspectionReportAttachmentRequest?: PatchedInspectionReportAttachmentRequest, options?: RequestInit): Promise<inspectionReportsAttachmentsPartialUpdateResponse> => {

  return customFetch<inspectionReportsAttachmentsPartialUpdateResponse>(getInspectionReportsAttachmentsPartialUpdateUrl(inspectionReportPk,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedInspectionReportAttachmentRequest)
  }
);}


export type inspectionReportsAttachmentsDestroyResponse204 = {
  data: void
  status: 204
}

export type inspectionReportsAttachmentsDestroyResponseSuccess = (inspectionReportsAttachmentsDestroyResponse204) & {
  headers: Headers;
};
;

export type inspectionReportsAttachmentsDestroyResponse = (inspectionReportsAttachmentsDestroyResponseSuccess)

export const getInspectionReportsAttachmentsDestroyUrl = (inspectionReportPk: string,
    id: string,) => {




  return `/api/v1/inspection-reports/${inspectionReportPk}/attachments/${id}/`
}

export const inspectionReportsAttachmentsDestroy = async (inspectionReportPk: string,
    id: string, options?: RequestInit): Promise<inspectionReportsAttachmentsDestroyResponse> => {

  return customFetch<inspectionReportsAttachmentsDestroyResponse>(getInspectionReportsAttachmentsDestroyUrl(inspectionReportPk,id),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type inspectionReportsRetrieveResponse200 = {
  data: InspectionReportDetail
  status: 200
}

export type inspectionReportsRetrieveResponseSuccess = (inspectionReportsRetrieveResponse200) & {
  headers: Headers;
};
;

export type inspectionReportsRetrieveResponse = (inspectionReportsRetrieveResponseSuccess)

export const getInspectionReportsRetrieveUrl = (id: string,) => {




  return `/api/v1/inspection-reports/${id}/`
}

/**
 * ViewSet for managing inspection reports.
 */
export const inspectionReportsRetrieve = async (id: string, options?: RequestInit): Promise<inspectionReportsRetrieveResponse> => {

  return customFetch<inspectionReportsRetrieveResponse>(getInspectionReportsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type inspectionReportsUpdateResponse200 = {
  data: InspectionReportCreateUpdate
  status: 200
}

export type inspectionReportsUpdateResponseSuccess = (inspectionReportsUpdateResponse200) & {
  headers: Headers;
};
;

export type inspectionReportsUpdateResponse = (inspectionReportsUpdateResponseSuccess)

export const getInspectionReportsUpdateUrl = (id: string,) => {




  return `/api/v1/inspection-reports/${id}/`
}

/**
 * ViewSet for managing inspection reports.
 */
export const inspectionReportsUpdate = async (id: string,
    inspectionReportCreateUpdateRequestRequest: InspectionReportCreateUpdateRequestRequest, options?: RequestInit): Promise<inspectionReportsUpdateResponse> => {

  return customFetch<inspectionReportsUpdateResponse>(getInspectionReportsUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inspectionReportCreateUpdateRequestRequest)
  }
);}


export type inspectionReportsPartialUpdateResponse200 = {
  data: InspectionReportCreateUpdate
  status: 200
}

export type inspectionReportsPartialUpdateResponseSuccess = (inspectionReportsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type inspectionReportsPartialUpdateResponse = (inspectionReportsPartialUpdateResponseSuccess)

export const getInspectionReportsPartialUpdateUrl = (id: string,) => {




  return `/api/v1/inspection-reports/${id}/`
}

/**
 * ViewSet for managing inspection reports.
 */
export const inspectionReportsPartialUpdate = async (id: string,
    patchedInspectionReportCreateUpdateRequestRequest?: PatchedInspectionReportCreateUpdateRequestRequest, options?: RequestInit): Promise<inspectionReportsPartialUpdateResponse> => {

  return customFetch<inspectionReportsPartialUpdateResponse>(getInspectionReportsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedInspectionReportCreateUpdateRequestRequest)
  }
);}


export type inspectionReportsDestroyResponse204 = {
  data: void
  status: 204
}

export type inspectionReportsDestroyResponseSuccess = (inspectionReportsDestroyResponse204) & {
  headers: Headers;
};
;

export type inspectionReportsDestroyResponse = (inspectionReportsDestroyResponseSuccess)

export const getInspectionReportsDestroyUrl = (id: string,) => {




  return `/api/v1/inspection-reports/${id}/`
}

/**
 * ViewSet for managing inspection reports.
 */
export const inspectionReportsDestroy = async (id: string, options?: RequestInit): Promise<inspectionReportsDestroyResponse> => {

  return customFetch<inspectionReportsDestroyResponse>(getInspectionReportsDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type inspectionReportsAddViolationsCreateResponse200 = {
  data: InspectionReportList
  status: 200
}

export type inspectionReportsAddViolationsCreateResponseSuccess = (inspectionReportsAddViolationsCreateResponse200) & {
  headers: Headers;
};
;

export type inspectionReportsAddViolationsCreateResponse = (inspectionReportsAddViolationsCreateResponseSuccess)

export const getInspectionReportsAddViolationsCreateUrl = (id: string,) => {




  return `/api/v1/inspection-reports/${id}/add_violations/`
}

/**
 * Add violations to an inspection report
 */
export const inspectionReportsAddViolationsCreate = async (id: string,
    inspectionReportListRequest: InspectionReportListRequest, options?: RequestInit): Promise<inspectionReportsAddViolationsCreateResponse> => {

  return customFetch<inspectionReportsAddViolationsCreateResponse>(getInspectionReportsAddViolationsCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inspectionReportListRequest)
  }
);}


export type inspectionReportsRemoveViolationsCreateResponse200 = {
  data: InspectionReportList
  status: 200
}

export type inspectionReportsRemoveViolationsCreateResponseSuccess = (inspectionReportsRemoveViolationsCreateResponse200) & {
  headers: Headers;
};
;

export type inspectionReportsRemoveViolationsCreateResponse = (inspectionReportsRemoveViolationsCreateResponseSuccess)

export const getInspectionReportsRemoveViolationsCreateUrl = (id: string,) => {




  return `/api/v1/inspection-reports/${id}/remove_violations/`
}

/**
 * Remove violations from an inspection report
 */
export const inspectionReportsRemoveViolationsCreate = async (id: string,
    inspectionReportListRequest: InspectionReportListRequest, options?: RequestInit): Promise<inspectionReportsRemoveViolationsCreateResponse> => {

  return customFetch<inspectionReportsRemoveViolationsCreateResponse>(getInspectionReportsRemoveViolationsCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inspectionReportListRequest)
  }
);}


export type inspectionReportsSupersessionDecisionsCreateResponse200 = {
  data: SupersessionSummary
  status: 200
}

export type inspectionReportsSupersessionDecisionsCreateResponseSuccess = (inspectionReportsSupersessionDecisionsCreateResponse200) & {
  headers: Headers;
};
;

export type inspectionReportsSupersessionDecisionsCreateResponse = (inspectionReportsSupersessionDecisionsCreateResponseSuccess)

export const getInspectionReportsSupersessionDecisionsCreateUrl = (id: string,) => {




  return `/api/v1/inspection-reports/${id}/supersession-decisions/`
}

/**
 * Apply per-violation supersession decisions for a saved report.
 *
 * Request: {"decisions": [{"violation_id", "decision", "resolution_notes"?,
 * "resolution_type"?, "custom_resolution_type"?}]}. decision is one of
 * superseded / resolved / carry_forward. The whole batch is atomic and is
 * scoped to open violations on the report's car. This is a request-driven,
 * human action — the AI auto-approval path never calls it.
 */
export const inspectionReportsSupersessionDecisionsCreate = async (id: string,
    supersessionDecisionsRequestRequest: SupersessionDecisionsRequestRequest, options?: RequestInit): Promise<inspectionReportsSupersessionDecisionsCreateResponse> => {

  return customFetch<inspectionReportsSupersessionDecisionsCreateResponse>(getInspectionReportsSupersessionDecisionsCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(supersessionDecisionsRequestRequest)
  }
);}


export type inspectionReportsViolationsRetrieveResponse200 = {
  data: InspectionReportList
  status: 200
}

export type inspectionReportsViolationsRetrieveResponseSuccess = (inspectionReportsViolationsRetrieveResponse200) & {
  headers: Headers;
};
;

export type inspectionReportsViolationsRetrieveResponse = (inspectionReportsViolationsRetrieveResponseSuccess)

export const getInspectionReportsViolationsRetrieveUrl = (id: string,) => {




  return `/api/v1/inspection-reports/${id}/violations/`
}

/**
 * Retrieve violations associated with an inspection report
 */
export const inspectionReportsViolationsRetrieve = async (id: string, options?: RequestInit): Promise<inspectionReportsViolationsRetrieveResponse> => {

  return customFetch<inspectionReportsViolationsRetrieveResponse>(getInspectionReportsViolationsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


